import React from "react";
import { INDUSTRY } from "../../../core/theme/auditsTheme";

// The data gathering strip across the top of the Market panel. Gathering now
// and Snapshots come from the list (so they always match its rows); Searches
// this week and Locations covered from the roll-up ("—" until it's there).
// The live dot only shows while something is gathering, and doesn't pulse
// for anyone who has asked for reduced motion.
export default function GatheringStrip({ industry, niche }) {
  const n = value => (value == null ? "—" : Number(value).toLocaleString("en-GB"));
  const tiles = [
    { label: "Gathering now", value: n(industry.running), live: industry.running > 0 },
    { label: "Searches this week", value: n(niche ? niche.searchesThisWeek : null) },
    { label: "Locations covered", value: n(niche ? niche.locations : null) },
    { label: "Snapshots", value: n(industry.snapshots) },
  ];

  return (
    <div className={INDUSTRY.strip}>
      {tiles.map(t => (
        <div key={t.label} className={INDUSTRY.stripTile}>
          <div className={INDUSTRY.label}>{t.label}</div>
          <div className={INDUSTRY.stripValueRow}>
            {t.live && (
              <span className={INDUSTRY.live} aria-hidden="true">
                <span className={INDUSTRY.livePing} />
                <span className={INDUSTRY.liveDot} />
              </span>
            )}
            <span className={INDUSTRY.stripValue}>{t.value}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
